
import { z } from "zod";

export const campaignFormSchema = z.object({
  title: z.string().min(3, { message: "Title must be at least 3 characters" }),
  description: z.string().min(10, { message: "Description must be at least 10 characters" }),
  campaignType: z.enum(["unique", "common"], {
    required_error: "Please select a campaign type",
  }),
  voucherCount: z.number().min(1, { message: "Must create at least 1 voucher" }),
  startDate: z.date({ required_error: "Start date is required" }),
  endDate: z.date({ required_error: "End date is required" }),
  voucherImage: z.string().optional(),
  voucherDetails: z.string().min(10, { message: "Voucher details must be at least 10 characters" }),
  sponsorName: z.string().min(1, { message: "Sponsor name is required" }),
  sponsorMessage: z.string().optional(),
  venues: z.array(z.string()),
  isDraft: z.boolean().default(false),
});

// Mock venues for demonstration - moved from the form component
export const mockVenues = [
  { id: "v1", name: "The Beer Garden" },
  { id: "v2", name: "Hops & Dreams" },
  { id: "v3", name: "Craft Corner" },
  { id: "v4", name: "Brew House" },
  { id: "v5", name: "Malt Masters" },
];

export const voucherOptions = [50, 100, 200, 500, 1000, 2000];
